var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowPreviousIcon = function SvgArrowPreviousIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "#0592AF"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.67 3.87 13.9 2.1 4 12l9.9 9.9 1.77-1.77L7.54 12z"
  })));
};
export default SvgArrowPreviousIcon;